// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkboxAndText_XALk_ {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 7px;
	color: var(--_3c3a3a-color);
	font-size: 12px;
}

.textContainer_sVd0j {
	color: text;
}
.subtextContainer_PnZM3 {
	color: var(--text-color-secondary);
	font-size: 11px;
}

.checkboxIcon_pCsUo {
	color: var(--_10a37f-background);
}

.checkedButton_cphYG {
	background: transparent;
	padding: 3px;
	border-radius: 50%;
	border: none;
	transition:
		background-color 0.2s ease-in-out,
		transform 0.2s ease-in-out;
	animation: checkboxCheckedAnimation_zPKeS 0.25s ease;
	&:hover {
		background-color: var(--f5-background);
	}
}

.uncheckedButton_JPuxs {
	padding: 3px;
	border-radius: 50%;
	border: none;
	transition:
		background-color 0.2s ease-in-out,
		transform 0.2s ease-in-out;
	animation: checkboxUncheckedAnimation_rstLb 0.25s ease;
	background: transparent;
	&:hover {
		background-color: var(--f5-background);
	}
}

@keyframes checkboxCheckedAnimation_zPKeS {
	0% {
		transform: scale(0.85);
	}
	50% {
		transform: scale(1.1);
	}
	100% {
		transform: scale(1);
	}
}

@keyframes checkboxUncheckedAnimation_rstLb {
	0% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.1);
	}
	100% {
		transform: scale(0.85);
	}
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/CheckboxAndText.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,QAAQ;CACR,2BAA2B;CAC3B,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;AACA;CACC,kCAAkC;CAClC,eAAe;AAChB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,uBAAuB;CACvB,YAAY;CACZ,kBAAkB;CAClB,YAAY;CACZ;;4BAE2B;CAC3B,oDAA8C;CAC9C;EACC,sCAAsC;CACvC;AACD;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,YAAY;CACZ;;4BAE2B;CAC3B,sDAAgD;CAChD,uBAAuB;CACvB;EACC,sCAAsC;CACvC;AACD;;AAEA;CACC;EACC,sBAAsB;CACvB;CACA;EACC,qBAAqB;CACtB;CACA;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,mBAAmB;CACpB;CACA;EACC,qBAAqB;CACtB;CACA;EACC,sBAAsB;CACvB;AACD","sourcesContent":[".checkboxAndText {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tgap: 7px;\n\tcolor: var(--_3c3a3a-color);\n\tfont-size: 12px;\n}\n\n.textContainer {\n\tcolor: text;\n}\n.subtextContainer {\n\tcolor: var(--text-color-secondary);\n\tfont-size: 11px;\n}\n\n.checkboxIcon {\n\tcolor: var(--_10a37f-background);\n}\n\n.checkedButton {\n\tbackground: transparent;\n\tpadding: 3px;\n\tborder-radius: 50%;\n\tborder: none;\n\ttransition:\n\t\tbackground-color 0.2s ease-in-out,\n\t\ttransform 0.2s ease-in-out;\n\tanimation: checkboxCheckedAnimation 0.25s ease;\n\t&:hover {\n\t\tbackground-color: var(--f5-background);\n\t}\n}\n\n.uncheckedButton {\n\tpadding: 3px;\n\tborder-radius: 50%;\n\tborder: none;\n\ttransition:\n\t\tbackground-color 0.2s ease-in-out,\n\t\ttransform 0.2s ease-in-out;\n\tanimation: checkboxUncheckedAnimation 0.25s ease;\n\tbackground: transparent;\n\t&:hover {\n\t\tbackground-color: var(--f5-background);\n\t}\n}\n\n@keyframes checkboxCheckedAnimation {\n\t0% {\n\t\ttransform: scale(0.85);\n\t}\n\t50% {\n\t\ttransform: scale(1.1);\n\t}\n\t100% {\n\t\ttransform: scale(1);\n\t}\n}\n\n@keyframes checkboxUncheckedAnimation {\n\t0% {\n\t\ttransform: scale(1);\n\t}\n\t50% {\n\t\ttransform: scale(1.1);\n\t}\n\t100% {\n\t\ttransform: scale(0.85);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxAndText": `checkboxAndText_XALk_`,
	"textContainer": `textContainer_sVd0j`,
	"subtextContainer": `subtextContainer_PnZM3`,
	"checkboxIcon": `checkboxIcon_pCsUo`,
	"checkedButton": `checkedButton_cphYG`,
	"checkboxCheckedAnimation": `checkboxCheckedAnimation_zPKeS`,
	"uncheckedButton": `uncheckedButton_JPuxs`,
	"checkboxUncheckedAnimation": `checkboxUncheckedAnimation_rstLb`
};
export default ___CSS_LOADER_EXPORT___;
